// Web-only strings for the DM header's presence line and device drill-in (core/lastSeenPresentation,
// core/deviceIndicatorPresentation), BOTH languages. The presence words themselves («En línea»,
// «Ausente», «No molestar») and the drill-in's «Computadora» / «Celular» / «Activo ahora» /
// «Sin registro» are the Apple keys (profile.status.*, profile.device.*).
export const strings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.lastSeen.justNow': 'Últ. vez hace un momento',
    'web.lastSeen.minutes': 'Últ. vez hace %d min',
    'web.lastSeen.today': 'Últ. vez hoy a las %@',
    'web.lastSeen.yesterday': 'Últ. vez ayer a las %@',
    'web.lastSeen.weekday': 'Últ. vez el %@ a las %@',
    'web.lastSeen.date': 'Últ. vez el %@ a las %@',
    'web.device.desktop': 'computadora',
    'web.device.mobile': 'celular',
    'web.device.both': 'computadora y celular',
    'web.device.show': 'Conexión por dispositivo',
  },
  en: {
    'web.lastSeen.justNow': 'Last seen just now',
    'web.lastSeen.minutes': 'Last seen %d min ago',
    'web.lastSeen.today': 'Last seen today at %@',
    'web.lastSeen.yesterday': 'Last seen yesterday at %@',
    'web.lastSeen.weekday': 'Last seen %@ at %@',
    'web.lastSeen.date': 'Last seen %@ at %@',
    'web.device.desktop': 'computer',
    'web.device.mobile': 'mobile',
    'web.device.both': 'computer and mobile',
    'web.device.show': 'Connection by device',
  },
};
